export const normalizePhoneCode = (code?: string | number) => {
    if (!code && code !== 0) return "";
    const s = String(code).trim();
    const m = s.match(/\+?(\d+)/);
    if (m && m[1]) return `+${m[1]}`;
    return s;
};

export default normalizePhoneCode;
